import { ErrorMessage } from '@hookform/error-message';
import { ReactNode } from 'react';
import { Control, FieldPathByValue, FieldValues, useController } from 'react-hook-form';

import { Form, FormControlProps, InputGroup } from '../../../../bootstrap';
import { Hint } from '../Hint';

// There might be a better way to do this, the errors in TS
// can become confusing if you forget a prop like `label`
type Props<T extends FieldValues> = {
  // Only allow string values to be used with this component
  fieldName: FieldPathByValue<T, string | undefined> | FieldPathByValue<T, number | undefined>;
  control: Control<T>;
  label?: ReactNode;
  hint?: ReactNode;
  required?: boolean;
  hideErrorMessage?: boolean;
  disabled?: boolean;
  step?: number;
} & Pick<FormControlProps, 'autoFocus' | 'placeholder'>;

export function ControlledPercentInput<T extends FieldValues>({
  label,
  required,
  hint,
  control,
  fieldName,
  hideErrorMessage,
  step = 0.001,
  ...props
}: Props<T>) {
  const {
    field,
    formState: { errors },
  } = useController({ name: fieldName, control });

  return (
    <>
      {label && (
        <Form.Label className="u-fs-2 fw-bold">
          {label}
          {required && <span className="u-color-red1 ps-1 ">*</span>}
        </Form.Label>
      )}
      <InputGroup>
        <Form.Control
          type="number"
          placeholder="0.000"
          step={step}
          aria-describedby="ir-rate"
          {...field}
          value={field.value ?? ''}
          {...props}
        />
        <InputGroup.Text id="ir-rate" className="u-color-red">
          %
        </InputGroup.Text>
      </InputGroup>

      {hint && <Hint>{hint}</Hint>}
      {!hideErrorMessage && (
        <ErrorMessage
          errors={errors}
          name={fieldName as any} // This *should* work without casting but it doesn't
          render={({ message }) => <div className="u-fs-2 u-color-red1">{message}</div>}
        />
      )}
    </>
  );
}
